import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_3,
  ANALYTICS_COLOR_4,
  ANALYTICS_COLOR_5,
  ANALYTICS_COLOR_6,
  ANALYTICS_COLOR_POSTS,
  TWITTER
} from '../../../config/constants';
import {
  METRIC_FACEBOOK_PAGE_IMPRESSIONS,
  METRIC_TWITTER_ACCOUNT_FOLLOWERS_COUNT,
  METRIC_TWITTER_ACCOUNT_FRIENDS_COUNT,
  METRIC_TWITTER_POST_FAVORITE_COUNT,
  METRIC_TWITTER_POST_RETWEET_COUNT
} from '../../../config/metrics';
import { displayFunctions } from '../../../utils/chartsUtils';
import {
  DEMO_DATA_FACEBOOK_ENGAGEMENET_REATIONS,
  DEMO_DATA_GOOGLE_CLICKS_WEBSITE
} from '../../../utils/demoDataUtils/demoDataArrays';
import { getStaticDataPoints } from '../../../utils/demoDataUtils/demoDataFunctions';

const filters = {
  filters: []
};
export const config: any = {
  shouldBeCached: false,
  ...filters,

  metrics: [
    {
      metrics: [METRIC_FACEBOOK_PAGE_IMPRESSIONS],
      title: 'organic',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line'
      // formula: 'delta'
    }
  ]
};

export const followersDevelopmentConfig: any = {
  shouldBeCached: false,
  ...filters,
  no_data_available: 'no_data_available',
  metrics: [
    {
      metrics: [METRIC_TWITTER_ACCOUNT_FOLLOWERS_COUNT],
      title: 'followers',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'bar',
      formula: 'delta',
      display: 'max'
    }
  ]
};

export const growthConfig: any = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //   title: 'tweets',
  //   platform: TWITTER,
  //   iconCssClass: 'fas fab-facebook',
  //   hexColor: ANALYTICS_COLOR_YELLOW,
  //   type: 'bar'
  // },

  metrics: [
    {
      metrics: [METRIC_TWITTER_ACCOUNT_FOLLOWERS_COUNT],
      title: 'followers',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      platform: TWITTER,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [224, 224, 221, 226, 227, 230, 230, 230]
        }
      }
    },

    {
      metrics: [METRIC_TWITTER_ACCOUNT_FRIENDS_COUNT],
      title: 'following',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      platform: TWITTER,
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: [120, 132, 186, 187, 185, 195, 227, 245]
        }
      }
    }
  ]
};

const interactionsConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //   title: 'tweets',
  //   iconCssClass: 'fas fab-facebook',
  //   hexColor: ANALYTICS_COLOR_YELLOW,
  //   type: 'bar'
  // },

  metrics: [
    {
      metrics: [METRIC_TWITTER_POST_RETWEET_COUNT],
      title: 'retweets',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_CLICKS_WEBSITE
        }
      }
    }
  ]
};

const summaryConfig = {
  shouldBeCached: false,
  ...filters,
  // bar_plot_config: {
  //   title: 'tweets',
  //   iconCssClass: 'fas fab-facebook',
  //   hexColor: ANALYTICS_COLOR_YELLOW,
  //   type: 'bar'
  // },

  metrics: [
    // {
    //     metrics: [METRIC_TWITTER_CUMULATED_IMPRESSIONS],
    //     title: 'impressions',
    //     iconCssClass: 'fas fab-facebook',
    //     hexColor: ANALYTICS_COLOR_1,
    //     type: 'line',
    //     formula: 'delta',
    //     display: 'sum',
    // },
    {
      metrics: [
        METRIC_TWITTER_POST_FAVORITE_COUNT,
        METRIC_TWITTER_POST_RETWEET_COUNT
      ],
      title: 'interactions',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      formula: 'delta',
      display: 'sum',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_FACEBOOK_ENGAGEMENET_REATIONS
        }
      }
    }
  ]
};

export const postsConfig = {
  summary: summaryConfig,
  interactions: interactionsConfig
};

// -----------------------------------
export const postsPerDayPlot = {
  posts_per_day_plot: {
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_1,
    type: 'bar',

    display: displayFunctions.sum
  }
};

export const newConfigsMap: any = {
  favourites_count: {
    addAdditionalPlots: true,
    favourites_count: {
      title: 'mixedChart.favourites_count',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  followers_count: {
    addAdditionalPlots: true,

    followers_count: {
      title: 'mixedChart.followers_count',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  friends_count: {
    addAdditionalPlots: true,

    friends_count: {
      title: 'mixedChart.friends_count',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  listed_count: {
    addAdditionalPlots: true,

    listed_count: {
      title: 'mixedChart.listed_count',
      hexColor: ANALYTICS_COLOR_4,
      type: 'line',

      display: displayFunctions.sum
    }
  },
  statuses_count: {
    addAdditionalPlots: true,

    statuses_count: {
      title: 'mixedChart.statuses_count',
      hexColor: ANALYTICS_COLOR_6,
      type: 'line',

      display: displayFunctions.sum
    }
  },

  posts_per_day: {
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_5,
    type: 'bar',
    display: displayFunctions.sum,
    normalizeValues: true,
    additionalPlot: true
  }
};
